var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AppLayout',[_c('VContainer',{attrs:{"fluid":"","fill-height":"","id":"login-page"}},[_c('VRow',{staticClass:"overflow-x-hidden overflow-y-auto",attrs:{"align-center":"","justify-center":""}},[_c('VCol',{attrs:{"lg":"6","md":"8","sm":"12"}},[_c('LoginForm')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }